import React from 'react';
import { connect, useDispatch } from 'react-redux';
// import { NotFoundPage, TopbarContainer } from '../../containers';
import FooterContainer from '../FooterContainer/FooterContainer.js';
// import NotFoundPage from '../NotFoundPage/NotFoundPage';

import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer'
import NotFoundPage from '../NotFoundPage/NotFoundPage';
// import LayoutWrapperTopbar from '../../components/LayoutWrapperTopbar/LayoutWrapperTopbar'
// import LayoutWrapperMain from '../../components/LayoutWrapperMain/LayoutWrapperMain'
// import LayoutWrapperFooter from '../../components/LayoutWrapperFooter/LayoutWrapperFooter'
// import Footer from '../../components/Footer/Footer'
import BlogCard from '../../components/BlogCard/BlogCard'
import {
  // BlogCard,
  // Footer,
  // IconSpinner,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  // Page,
} from '../../components/LayoutComposer';
import IconSpinner from '../IconSpinner/IconSpinner.js';
// import IconSpinner from '../../components';
import {Page} from '../../components'
import { fetchNextPage } from './BlogPostsPage.duck';
import css from './BlogPostsPage.module.css';
import Pagination from 'rc-pagination';
import classNames from 'classnames';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import './tailwind.css';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import NotResultFoundPage from './NoResultFoundPage';
import { injectIntl } from '../../util/reactIntl';

function BlogPostsPage(props) {
  const {
    posts,
    postsLoading,
    postsLoadingError,
    onfetchNextPage,
    currentPage,
    totalPostsCount,
    pageSize,
    history,
    scrollingDisabled,
    intl,
  } = props;
  console.log("posts of blog page",posts)

  // if (postsLoading) return <div>Loading...</div>;

  const schemaTitle = intl.formatMessage({ id: 'BlogPostsPage.schemaTitle' });
  const description = intl.formatMessage({ id: 'BlogPostsPage.schemaDescription' });
  const schemaImages = '';
  const topbar = <TopbarContainer currentPage="BlogPostsPage" />;

  const handlePageChange = (current, pageSize) => {
    // console.log(current);
    history.push({
      pathname: '/blog',
      search: `?page=${current}`,
    });
    onfetchNextPage(current);
  };
  const customPageMarkUp = (page, type, element) => {
    return (
      <a
        onClick={e => e.preventDefault()}
        // className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-100"
      >
        {type == 'page' ? page : type.charAt(0).toUpperCase() + type.slice(1)}
      </a>
    );
  };

  if (postsLoading) return <LoadingPage />;
  if (postsLoadingError) return <NotFoundPage />;

  if (Math.ceil(totalPostsCount / pageSize) < currentPage) {
    if (posts?.length == 0) return <NotResultFoundPage />;
    else return <NotFoundPage />;
  }

  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      // author={authorDisplayName}
      contentType="website"
      description={description}
      // facebookImages={facebookImages}
      // twitterImages={twitterImages}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ItemPage',
        description: description,
        name: schemaTitle,
        image: schemaImages,
      }}
    >
      {/* {Math.ceil(totalPostsCount / pageSize) < currentPage ? (
        posts?.length == 0 ? (
          <NotResultFoundPage />
        ) : (
          <NotFoundPage />
        )
      ) : ( */}
      <LayoutSingleColumn className={css.pageRoot}>
        <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className="parentWrapper">
            <div className="relative bg-gray-50 pt-16 pb-20 px-4 sm:px-6 lg:pt-4 lg:pb-4 lg:px-8">
              <div className="relative max-w-7xl mx-auto">
                <div className="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
                  {posts?.map((post, index) => <BlogCard key={index} css={css} {...post} />)}
                </div>
              </div>
              <Pagination
                current={currentPage}
                total={totalPostsCount}
                defaultPageSize={pageSize}
                pageSize={pageSize}
                locale="en_US"
                onChange={handlePageChange}
                // showPrevNextJumpers={true}
                // jumpPrevIcon={<span>Prev</span>}
                // jumpNextIcon={<span>Next</span>}
                itemRender={customPageMarkUp}
                prevIcon={<span className={css.next}>Prev</span>}
                nextIcon={<span className={css.prev}>Next</span>}
                // className={css.pagination}
                className={classNames('relative', 'z-0', 'rounded-md', css.pagination)}
              />
            </div>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
        <FooterContainer/>

          {/* <Footer /> */}
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
      {/* )} */}
    </Page>
  );
}

// <div>
//     {posts.map((post, index) => <BlogCard {...post} key={index} />)}
// </div>
const mapStateToProps = state => {
  const { BlogPostsPage } = state;
  return {
    ...BlogPostsPage,
    scrollingDisabled: isScrollingDisabled(state),
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onfetchNextPage: page => dispatch(fetchNextPage(page)),
  };
};

export default compose(
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(BlogPostsPage);

const LoadingPageComponent = props => {
  const { scrollingDisabled } = props;
  return (
    <Page
      title="Loading ..."
      scrollingDisabled={scrollingDisabled}
      // author={authorDisplayName}
      contentType="website"
      description="Loading ..."
      // facebookImages={facebookImages}
      // twitterImages={twitterImages}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ItemPage',
        description: 'Loading...',
        name: 'Loading ...',
        image: 'Loading ...',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="BlogPostsPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.loadingContainer}>
            <IconSpinner className={css.loading} />
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          {/* <Footer />\ */}
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToPropsLoading = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};
const mapDispatchToPropsLoading = dispatch => ({});

export const LoadingPage = compose(
  connect(
    mapStateToPropsLoading,
    mapDispatchToPropsLoading
  )
)(LoadingPageComponent);
